export const ultimasNoticias = [
     
    
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_127.png",
        "url" : "https://www.facebook.com/share/p/1GgfZuJL9z/",
        "titulo" : 'Revisión y analisis de terrenos para la reubicación de viviendas',
        "fecha" : "01/04/2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_128.png",
        "url" : "https://www.facebook.com/share/p/16qxhJRwZ9/",
        "titulo" : 'Entrega de reconocimientos a personas artesanas',
        "fecha" : "20/03/2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_125.png",
        "url" : "https://www.facebook.com/share/p/1C1BF52ZHp/",
        "titulo" : 'Reunion de Gabinete',
        "fecha" : "06-03-2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_126.png",
        "url" : "https://www.facebook.com/share/p/1FifWVWK53/",
        "titulo" : 'Entrega de apoyos y certificados de secundaria',
        "fecha" : "05/03/2026"
    },
    
]